// Welcome modal (first visit)
import { isSignedIn } from './state.js';
import { triggerGoogleSignIn } from './auth.js';

export function checkFirstVisit() {
  const hasVisited = localStorage.getItem('hasVisited');
  if (!hasVisited && !isSignedIn) {
    showWelcomeModal();
  }
}

export function showWelcomeModal() {
  const modal = document.getElementById('welcome-modal');
  if (modal) modal.classList.add('active');
}

export function closeWelcomeModal() {
  const modal = document.getElementById('welcome-modal');
  if (modal) {
    modal.classList.remove('active');
    localStorage.setItem('hasVisited', 'true');
  }
}

export function handleWelcomeSignIn() {
  closeWelcomeModal();
  triggerGoogleSignIn();
}

export function handleWelcomeSkip() {
  closeWelcomeModal();
}
